import React from 'react';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

export default function DeleteConfirmation(props) {
    const { handleDeleteClose, onYes, open, title, message } = props;

    return (
        <Dialog open={open} onClose={handleDeleteClose} fullWidth maxWidth="xs" component="form">
            <AppBar position="static">
                <Toolbar className="flex w-full justify-between">
                    <Typography variant="subtitle1" color="inherit">
                        {title}
                    </Typography>
                    <IconButton onClick={handleDeleteClose}>
                        <Icon>close</Icon>
                    </IconButton>
                </Toolbar>
            </AppBar>

            <form>
                <DialogContent classes={{ root: 'p-16 sm:p-24' }}>
                    {message}
                </DialogContent>

                <DialogActions className="px-8 sm:px-16">
                    <Button onClick={onYes} variant="contained" color="primary" type="button">
                        Yes
                    </Button>
                    <Button onClick={handleDeleteClose} variant="outlined" color="inherit" type="button" >
                        Close
                    </Button>
                </DialogActions>

            </form>
        </Dialog>
    );
}
